import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Guard } from '../../components/layout/Guard';

const ReportsPage = lazy(() => import('./ReportsPage'));

const routes: RouteObject[] = [
  { path: '/reports', element: <Guard any={['report.financial', 'report.operational', 'report.department', 'report.executive']}><ReportsPage /></Guard> },
];
export default routes;
